import loadable from '@loadable/component';
import { Route, Routes } from 'react-router';
import Toasts from 'src/components/sections/toasts';
import MainLayout from 'src/layout/main';
import styles from './index.sass';
import './general.sass';

const NotFoundPage = loadable(async () => await import('src/pages/other/404'));

const PlanPage = loadable(async () => await import('src/pages/plan'));

function Layout() {
	return (
		<main className={styles.layout}>
			<Toasts rtl />

			<Routes>
				<Route element={<MainLayout />}>
					<Route path='/plan/:eventId/:startNodeId?/:endNodeId?' element={<PlanPage />} />
				</Route>

				<Route path={'*'} element={<NotFoundPage />} />
			</Routes>
		</main>
	);
}

export default Layout;
